import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    TextField,
    Typography
} from '@mui/material';
import ComputerIcon from '@mui/icons-material/Computer';

const VirtualLabDialog = ({
    open,
    onClose,
    labFormData,
    setLabFormData,
    onSubmit,
    theme
}) => (
    <Dialog
        open={open}
        onClose={onClose}
        fullWidth
        maxWidth="sm"
        PaperProps={{ sx: { borderRadius: '16px' } }}
    >
        <DialogTitle
            sx={{
                backgroundColor: theme.palette.primary.main,
                color: '#fff',
                p: 3,
                display: 'flex',
                alignItems: 'center',
                gap: 1.5
            }}
        >
            <ComputerIcon sx={{ color: theme.palette.secondary.main }} />
            <Box>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                    Add Virtual Lab
                </Typography>
                <Typography
                    variant="caption"
                    sx={{
                        color: 'rgba(255,255,255,0.7)',
                        display: 'block'
                    }}
                >
                    Attach a practical lab environment for this lesson.
                </Typography>
            </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 4, mt: 2 }}>
            <Stack spacing={3}>
                <TextField
                    fullWidth
                    label="Lab Name"
                    variant="outlined"
                    value={labFormData.labName}
                    onChange={(e) =>
                        setLabFormData({
                            ...labFormData,
                            labName: e.target.value
                        })
                    }
                />
                <TextField
                    fullWidth
                    label="Lab URL"
                    variant="outlined"
                    value={labFormData.url}
                    onChange={(e) =>
                        setLabFormData({
                            ...labFormData,
                            url: e.target.value
                        })
                    }
                />
            </Stack>
        </DialogContent>
        <DialogActions
            sx={{
                p: 3,
                backgroundColor: theme.palette.grey[50],
                borderTop: `1px solid ${theme.palette.divider}`
            }}
        >
            <Button
                onClick={onClose}
                color="inherit"
                sx={{
                    fontWeight: 600,
                    textTransform: 'none'
                }}
            >
                Cancel
            </Button>
            <Button
                onClick={onSubmit}
                variant="contained"
                color="secondary"
                sx={{
                    fontWeight: 'bold',
                    px: 3,
                    borderRadius: '8px',
                    textTransform: 'none'
                }}
            >
                Add Lab
            </Button>
        </DialogActions>
    </Dialog>
);

export default VirtualLabDialog;
